// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6ba850718a3818fff623","293":"e142638f61b3c76fb841","518":"7ecb45268d686d410955","779":"929317b16a7c6846b35f"}[chunkId] + ".js";
};